import React, { Component } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tooltip } from 'primereact/tooltip';
import { Toast } from 'primereact/toast';
import Service from '../../../services';
import { Menu } from 'primereact/menu';
import { FilterMatchMode } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import Authorizer, { PERMISSIONS } from '../../../session/authorizer';
import { BasicLazyParams, warningDailogInit } from '../../../../utile';
import { baseUrlAdmin, baseUrlForLongRunningTask } from '../../../../store/apiConstants';
import { Checkbox } from 'primereact/checkbox';
import SvgViewer from '../../../customComponents/svgViewer';
import { InputSwitch } from 'primereact/inputswitch';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog';
import moment from 'moment';
import AssignExamToSection from './assignExamToSection';
import LoadingComponent from '../../../loadingComponent';
import { AssignIcon, ExportIcon, WarningIcon } from '../../../svgIcons';
import axios from 'axios';
import AdhocExamResultUpload from './offlineExamResultUpload/adhocExamResultUpload';
import BranchToSectionDD from '../../../BaseDropdownComponents/BranchToSectionDD';
import { Calendar } from 'primereact/calendar';
import * as XLSX from 'xlsx';

const offlineContentBucket = process.env.REACT_APP_OFFLINE_CONTENT_BUCKET || 'classetofflinecontent-old';
const awsRegion = process.env.REACT_APP_AWS_REGION || 'ap-south-1';

export default class AdhocList extends Component {
    constructor(props) {
        super(props);

        this.state = {

            exams: [],

            columns: [{ columnName: 'Total Number Of Questions', isVisible: true, id: 'totalNoOfQuestions' },
            { columnName: 'Total Marked Questions', isVisible: true, id: 'totalMarkedQuestions' },
            { columnName: 'Total Time', isVisible: true, id: 'totalTime' },
            { columnName: 'Total Marks', isVisible: true, id: 'totalMarks' },
            ],
            showSearch: false,
            globalFilter: null,
            globalSearch: '',
            globalFilterValue: '',
            filters: {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            // totalRecords: 18,
            lazyParams: {
                ...BasicLazyParams,
                rows: 100
            },
            warningDialog: warningDailogInit,
            showDownloadDialog: false,
            selectedExamDate: new Date(),
            examToDownload: null,
        }
        this.service = new Service();
    }


    onGlobalSearch = (e) => {
        this.setState((prevState) => {
            return {

                globalSearch: e.target.value,
                lazyParams: BasicLazyParams
            }
        }, this.onSearch);
    }

    onPage = (event) => {

        this.setState((prevState) => {

            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.onSearch);
    }



    onSort = (event) => {


        this.setState((prevState) => {

            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        }, this.onSearch);
    }

    onFilter = (event) => {

        event['first'] = 0;
        this.setState((prevState) => {

            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    filters: event.filters
                }
            };
        }, this.onSearch);
        //  this.setState({ lazyParams: event }, this.getOrganizations);
    }

    onColumnClick = (column) => {
        let columns = this.state.columns.map(c => {
            if (column.id == c.id) {
                c.isVisible = !c.isVisible;
            }
            return c;
        });
        this.setState({
            columns
        });
    }


    isColumnVisible = (id) => {
        return this.state.columns.filter(c => c.id == id)[0].isVisible;
    }


    exportCSV = () => {
        this.dt.exportCSV();
    }

    onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let filters = { ...this.state.filters };
        filters['global'].value = value;
        this.setState({ filters, globalFilterValue: value });
    }

    componentDidMount() {
        this.onSearch();

    }


    // handleDownload = (url, filename) => {

    //     axios.get(url, {
    //         responseType: 'blob',
    //     })
    //         .then((res) => {

    //             const url = window.URL.createObjectURL(
    //                 new Blob([res.data]),
    //             );
    //             const link = document.createElement('a');
    //             link.href = url;
    //             link.setAttribute(
    //                 'download',
    //                 new Date().getTime().toString() + '.pdf',
    //             );

    //             // Append to html link element page
    //             document.body.appendChild(link);

    //             // Start download
    //             link.click();

    //             // Clean up and remove the link
    //             link.parentNode.removeChild(link);
    //             // fileDownload(res.data, filename)
    //         })
    // }

    handleDownload = (url, filename) => {

        axios.get(url, {
            responseType: 'blob',

        })
            .then((res) => {

                const url = window.URL.createObjectURL(
                    new Blob([res.data]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    filename,
                );

                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                // Clean up and remove the link
                link.parentNode.removeChild(link);
                // fileDownload(res.data, filename)
            })
    }

    genAndDownloadPaper = (rowData) => {
        this.setState({
            isLoading: true
        });

        let url = `${baseUrlForLongRunningTask}/longrunning/${rowData.examId}/download-paper`;

        axios.get(url, {
            headers: {
                'Access-Control-Allow-Origin': '*',
            }
        })
            .then((res) => {
                if (res && res.data && res.data.data && res.data.data.paperLink) {
                    this.handleDownload(`https://${offlineContentBucket}.s3.${awsRegion}.amazonaws.com/` + res.data.data.paperLink, res.data.data.paperLink);
                    this.setState({
                        isLoading: false
                    });
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: res.data?.message || 'Unable to download paper',
                        life: 3000
                    });
                }
            })
            .catch(error => {
                this.setState({
                    isLoading: false
                });

                // Handle error response
                const errorMessage = error.response?.data?.message || 'Failed to download paper';
                this.toast.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: errorMessage,
                    life: 3000
                });
            });
    }

    showDownloadDialog = (rowData) => {
        this.setState({
            showDownloadDialog: true,
            selectedExamDate: new Date(),
            examToDownload: rowData
        });
    }

    downloadPaperWithDate = () => {
        const { examToDownload, selectedExamDate } = this.state;

        if (!examToDownload || !selectedExamDate) {
            this.toast.show({
                severity: 'error',
                summary: 'Missing Information',
                detail: 'Please select an exam date',
                life: 3000
            });
            return;
        }

        this.setState({
            isLoading: true,
            showDownloadDialog: false
        });

        // Format date as required by your API (e.g., ISO string or custom format)
        const formattedDate = moment(selectedExamDate).format('YYYY-MM-DD');

        let url = `${baseUrlForLongRunningTask}/longrunning/${examToDownload.examId}/download-paper?examDate=${formattedDate}`;

        axios.get(url, {
            headers: {
                'Access-Control-Allow-Origin': '*',
            }
        })
            .then((res) => {
                if (res && res.data && res.data.data && res.data.data.paperLink) {
                    this.handleDownload(
                        `https://${offlineContentBucket}.s3.${awsRegion}.amazonaws.com/` + res.data.data.paperLink,
                        res.data.data.paperLink
                    );
                    this.setState({
                        isLoading: false
                    });
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({
                        severity: 'error',
                        summary: 'Download Failed',
                        detail: 'Unable to generate paper',
                        life: 3000
                    });
                }
            }).catch(e => {
                console.error("Paper download error:", e);
                this.setState({
                    isLoading: false
                });
                this.toast.show({
                    severity: 'error',
                    summary: 'Download Error',
                    detail: e.response?.data?.message || 'Failed to download paper',
                    life: 3000
                });
            });
    }

    onSearch = () => {
        const {
            lazyParams, globalSearch
        } = this.state;
        let filters = { examType: 'AdhocMockTest' };
        this.setState({
            isLoading: true,
            questions: [],
            totalRecords: 0
        });
        this.service.post(`${baseUrlAdmin}/examination/filter?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch}&examType=${'AdhocMockTest'}&academicYear=${localStorage.getItem('userAcademicYear') || ''}${lazyParams.sortField ? `&sort=${lazyParams.sortOrder == 1 ? '' : '-'}${lazyParams.sortField}` : ''}`, filters, true).then((data) => {
            if (data && data.status && data?.res?.data) {
                this.setState({
                    totalRecords: data.res.data.totalRecords,
                    exams: data.res.data.exams,
                    isLoading: false
                })
            } else {
                this.setState({
                    isLoading: false
                });

                this.toast.show({ severity: 'error', summary: 'No Exams', detail: "No Exams Found", life: 3000 });
            }


        }).catch(e => {
            this.setState({
                isLoading: false
            })

            this.toast.show({ severity: 'error', summary: 'Some error occured', detail: e.message, life: 3000 });
            console.log(e);

        });


    }


    changeStatus = (e, rowData) => {
        let data = { ...rowData }
        if (e.value == true) {
            data.status = 'Active'
        } else {
            data.status = 'InActive'
        }

        this.setState({
            warningDialog: {
                visible: true,
                headerMsg: 'Are you Sure?',
                message: `You are changing this Exam status ${e.value ? 'InActive' : 'Active'} to ${e.value ? 'Active.' : 'InActive'}`
            },
            editAssessmentData: data
        });
    }



    assignExam = (examToAssign) => {
        this.setState({
            isShowAssignDialog: true,
            examToAssign
        })

    }

    onAssignSuccess = () => {

        this.setState({
            isShowAssignDialog: false
        })
        // this.toast.show({ severity: 'success', summary: 'Assigned', detail: 'Successfully assigned', life: 3000 });
    }

    onConfirmExport = (examDetails) => {

        let { exportExamDetails } = this.state;

        this.setState({
            warningDialog: warningDailogInit,
            isLoading: true
        });

        this.service.get(`${baseUrlAdmin}/results/get/test/examId/${exportExamDetails.examId}/examType/${exportExamDetails.examType}/export`, true).then((data) => {

            if (data && data.status) {
                this.setState({
                    isLoading: false
                })
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Error', detail: data.errMessage, life: 3000 });
            }


        }).catch(e => {
            this.setState({
                isLoading: false
            })

            this.toast.show({ severity: 'error', summary: 'Some error occured', detail: e.message, life: 3000 });
            console.log(e);

        });


        setTimeout(() => {
            this.setState({
                isLoading: false
            });
            this.onSearch();
        }, 5000);

    };

    genAndDownloadReport = (rowData) => {
        this.setState({
            isLoading: true
        });

        let url = `${baseUrlAdmin}/longrunning/${rowData.examId}/download-reports`;

        axios.get(url, {
            headers: {
                'Access-Control-Allow-Origin': '*',
            }
        })
            .then((res) => {
                if (res?.data?.data?.paperLink) {
                    this.handleDownload(
                        `https://${offlineContentBucket}.s3.${awsRegion}.amazonaws.com/` + res.data.data.paperLink,
                        res.data.data.paperLink
                    );
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Report downloaded successfully',
                        life: 3000
                    });
                } else {
                    throw new Error(res.data?.message || 'Failed to generate report');
                }
            })
            .catch(error => {
                console.error('Report download error:', error);
                this.setState({
                    isLoading: false
                });

                // Handle 400 status code specifically
                if (error.response?.status === 400) {
                    this.toast.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'No students have attempted this exam yet',
                        life: 3000
                    });
                } else {
                    // Handle other errors
                    const errorMessage = error.response?.data?.message || error.message || 'Failed to download report';
                    this.toast.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: errorMessage,
                        life: 3000
                    });
                }
            });
    }

    showExportConfirm = (exportExam) => {
        if (exportExam.exported) {
            const lastExportMsg = exportExam.lastExportDate
                ? `Last exported on ${moment(exportExam.lastExportDate).format('MMM Do YYYY, h:mm:ss a')}`
                : 'This exam has already been exported';

            this.setState({
                exportExamDetails: exportExam,
                warningDialog: {
                    visible: true,
                    headerMsg: 'Already Exported',
                    message: `${lastExportMsg}. ${exportExam.exportMsg || ''}.\n\nDo you want to re-export? This will recalculate all results and analytics.`
                },
            });
        } else {
            this.setState({
                exportExamDetails: exportExam,
                warningDialog: {
                    visible: true,
                    headerMsg: 'Are you Sure?',
                    message: `Please make sure that, everyone attempted exam. If any user submit the exam after export, you have to export again to calculate for reports.`
                },
            });
        }
    }

    showUploadResult = (exam) => {
        this.setState({
            uploadResultExam: exam,
            isShowUploadResult: true
        })
    }



    recalculateExam = ({ examId }) => {
        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/results/recalculate`;
        this.setState({
            isLoading: true,

        });

        this.service.post(url, { examId }, true).then((data) => {

            if (data && data.status && data?.res?.status) {
                this.setState({
                    isLoading: false
                })
                this.toast.show({ severity: 'success', summary: 'Success', detail: "Successfully Recalculated the exam", life: 3000 });

            } else {
                this.setState({
                    isLoading: false
                });

                this.toast.show({ severity: 'error', summary: 'No Exams', detail: "No Exams Found", life: 3000 });
            }


        }).catch(e => {
            this.setState({
                isLoading: false
            })

            this.toast.show({ severity: 'error', summary: 'Some error occured', detail: e.message, life: 3000 });
            console.log(e);

        });
    }


    reloadExamQuestions = ({ examId }) => {

        this.setState({
            isLoading: true
        });
        let url = `${baseUrlAdmin}/examination/update-exam-questions`;
        this.setState({
            isLoading: true,

        });

        this.service.post(url, { examId }, true).then((data) => {

            if (data && data.status && data?.res?.status) {
                this.setState({
                    isLoading: false
                })
                this.toast.show({ severity: 'success', summary: 'Success', detail: "Successfully reloaded the exam Questions", life: 3000 });
            } else {
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'No Exams', detail: "No Exams Found", life: 3000 });
            }
        }).catch(e => {
            this.setState({
                isLoading: false
            })

            this.toast.show({ severity: 'error', summary: 'Some error occured', detail: e.message, life: 3000 });
            console.log(e);

        });
    }

    isExamAssignable = (rowData) => {
        if ((!rowData.fromDateTime || rowData.fromDateTime === "") &&
            (!rowData.toDateTime || rowData.toDateTime === "")) {
            return true;
        }

        if ((!rowData.fromDateTime || rowData.fromDateTime === "") ||
            (!rowData.toDateTime || rowData.toDateTime === "")) {
            return true;
        }

        const fromDate = new Date(rowData.fromDateTime);
        const toDate = new Date(rowData.toDateTime);
        const currentDate = new Date();

        return currentDate <= toDate;
    }

    handleNotifyParents = (rowData) => {
        confirmDialog({
            message: `Send result notifications for "${rowData.examName}" to parents via configured channels?`,
            header: 'Notify Parents',
            icon: 'pi pi-send',
            acceptClassName: 'p-button-primary',
            rejectClassName: 'p-button-outlined',
            accept: async () => {
                try {
                    this.setState({ isLoading: true });

                    const response = await this.service.post(
                        `${baseUrlAdmin}/notification-workflows/exam-result/send`,
                        {
                            examId: rowData.examId,
                            examType: 'objective'
                        },
                        true
                    );

                    if (response && response.status) {
                        this.toast.show({
                            severity: 'success',
                            summary: 'Success',
                            detail: `Notifications sent to ${response.res?.data?.totalStudents || 0} students`,
                            life: 3000
                        });
                    } else {
                        this.toast.show({
                            severity: 'error',
                            summary: 'Error',
                            detail: response?.message || 'Failed to send notifications',
                            life: 3000
                        });
                    }
                } catch (error) {
                    console.error('Error sending notifications:', error);
                    this.toast.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to send notifications',
                        life: 3000
                    });
                } finally {
                    this.setState({ isLoading: false });
                }
            }
        });
    }

    // downloadKey = (rowData) => {

    // }

    // downloadKey = (rowData) => {
    //     const examId = rowData.examId;
    //     // console.log('Downloading key for exam:', examId);
    //     // Your download logic here using examId

    //     this.setState({
    //         isLoading: true
    //     });
    //     let url = `${baseUrlAdmin}/key-download;
    // }

    downloadKey = (rowData) => {
        const examId = rowData.examId;
        const examName = rowData.examName;

        this.setState({
            isLoading: true
        });

        let url = `${baseUrlAdmin}/examination/key-download`;

        // Use the service class which handles authentication automatically
        this.service.post(url, { examId }, true)
            .then((res) => {
                console.log('Key download response++++++++++ res', res);

                // Fix: Check the correct response structure
                if (res && res.status && res.res && res.res.data && res.res.data.record) {
                    const keyData = res.res.data.record;
                    console.log('Key data received:===========', keyData);

                    // Convert the key-value data to Excel format
                    this.downloadAsXlsx(keyData, `answer-key-${examName}.xlsx`);

                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Answer key downloaded successfully',
                        life: 3000
                    });
                } else {
                    throw new Error(res.res?.data?.message || 'Failed to get answer key data');
                }
            })
            .catch(error => {
                console.error('Key download error:', error);
                this.setState({
                    isLoading: false
                });

                // Handle different error scenarios
                if (error.response?.status === 404) {
                    this.toast.show({
                        severity: 'error',
                        summary: 'Not Found',
                        detail: 'Answer key not available for this exam',
                        life: 3000
                    });
                } else if (error.response?.status === 400) {
                    this.toast.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Invalid exam or answer key not generated yet',
                        life: 3000
                    });
                } else if (error.response?.status === 401) {
                    this.toast.show({
                        severity: 'error',
                        summary: 'Unauthorized',
                        detail: 'Invalid or expired token',
                        life: 3000
                    });
                } else {
                    const errorMessage = error.response?.data?.message || error.message || 'Failed to download answer key';
                    this.toast.show({
                        severity: 'error',
                        summary: 'Download Error',
                        detail: errorMessage,
                        life: 3000
                    });
                }
            });
    }


    // Add this new method to convert data to Excel and download
    downloadAsXlsx = (data, filename) => {
        try {
            // Convert key-value data to worksheet format
            let worksheetData = [];

            if (Array.isArray(data)) {
                // If data is an array of objects
                worksheetData = data;
            } else if (typeof data === 'object' && data !== null) {
                // If data is a single object with key-value pairs
                worksheetData = Object.keys(data).map((key, index) => ({


                    // 'S.No': index + 1,
                    'Question Number': key,
                    'Correct Answer': Array.isArray(data[key]) ? data[key].join(', ') : data[key] || 'N/A'
                }));
            } else {
                throw new Error('Invalid data format for Excel export');
            }

            if (worksheetData.length === 0) {
                throw new Error('No data available to export');
            }

            // Create a new workbook and worksheet
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(worksheetData);

            // Add some styling (optional)
            const range = XLSX.utils.decode_range(worksheet['!ref']);
            for (let R = range.s.r; R <= range.e.r; ++R) {
                for (let C = range.s.c; C <= range.e.c; ++C) {
                    const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
                    if (!worksheet[cellAddress]) continue;

                    // Style header row
                    if (R === 0) {
                        worksheet[cellAddress].s = {
                            font: { bold: true },
                            fill: { fgColor: { rgb: "FFFFAA00" } }
                        };
                    }
                }
            }

            // Add the worksheet to the workbook
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Answer Key');

            // Write the workbook and trigger download
            XLSX.writeFile(workbook, filename);

            console.log('Excel file generated successfully');
        } catch (error) {
            console.error('Error generating Excel file:', error);
            this.toast.show({
                severity: 'error',
                summary: 'Export Error',
                detail: 'Failed to generate Excel file: ' + error.message,
                life: 3000
            });
        }
    }

    render() {
        const { exams } = this.state;
        const header = (
            <div className="flex justify-content-between bg-white">
                <div className="flex">
                    <h4 className=''>Adhoc Mock Test List</h4>
                    {this.state.showSearch && <InputText placeholder="Search" value={this.state.globalSearch} className="ml-4  h-2rem w-15rem" onChange={this.onGlobalSearch} />}
                </div>

                <div className="bg-blue-50 cursor-pointer mb-2 border-round">
                    <ul className="flex gap-5 mr-6">
                        {/* <Authorizer permId={PERMISSIONS.ORG_SEARCH} > */}
                        <i data-pr-tooltip="Search" data-pr-position="bottom" className="pi pi-search ma-tbl-icon ma-tbl-srch" onClick={(e) => { this.setState({ showSearch: !this.state.showSearch }) }}></i>
                        <Tooltip className="table-li-tooltip" autoHide={false} target=".ma-tbl-srch" />
                        {/* </Authorizer> */}
                        {/* <i data-pr-tooltip="Filter" data-pr-position="bottom" className="pi pi-filter ma-tbl-icon ma-tbl-fi"></i>
                        <Tooltip className="table-li-tooltip" target=".ma-tbl-fi" /> */}
                        <i onClick={(event) => this.menu.toggle(event)} data-pr-tooltip="View Columns" data-pr-position="bottom" className="pi pi-sort-alt ma-tbl-icon ma-tbl-sort"></i>
                        <Tooltip className="table-li-tooltip" target=".ma-tbl-sort" />
                        {/* <Authorizer permId={PERMISSIONS.ORG_VIEW_COLUMNS} >
                            
                        </Authorizer> */}
                        {/* <Authorizer permId={PERMISSIONS.ORG_DOWNLOAD} > */}
                        <i data-pr-tooltip="Download" data-pr-position="bottom" className="pi pi-download ma-tbl-icon ma-tbl-dwnld" onClick={this.exportCSV}></i>
                        <Tooltip className="table-li-tooltip" target=".ma-tbl-dwnld" />
                        {/* </Authorizer> */}
                    </ul>
                </div>
                <Menu
                    className=''
                    model={[
                        {
                            template: (<div className='ml-2 p-2'>
                                <h4 className="">View Columns</h4>
                                <ul>
                                    {this.state.columns.map((column) => {
                                        return <li key={column.id} onClick={() => this.onColumnClick(column)}><Checkbox inputId={column.id}
                                            checked={column.isVisible} className='mt-2'
                                        ></Checkbox>
                                            <label htmlFor={column.id} className="ml-2">{column.columnName}</label>
                                        </li>
                                    })}
                                </ul>
                            </div>)
                        }]
                    }
                    popup
                    ref={el => this.menu = el} />
            </div>
        );
        return (<>
            <Toast ref={(el) => this.toast = el} position="bottom-right" />
            <ConfirmDialog />
            <div className="card datatable-crud-demo ma-mt20 mt-3">
                {/* Search Input */}
                <div className="flex justify-content-start">
                    <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText
                            value={this.state.globalFilterValue}
                            onChange={this.onGlobalFilterChange}
                            placeholder="Keyword Search"
                        />
                    </span>
                </div>
                <DataTable ref={(el) => this.dt = el}
                    className="dataTableValuesText"
                    responsiveLayout="scroll"
                    dataKey="_id"
                    value={this.state.exams}
                    filters={this.state.filters}
                    paginator showGridlines
                    rows={this.state.lazyParams.rows}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    globalFilterFields={['examName', 'testType']}
                >
                    <Column style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} sortable headerClassName="text-color-secondary" bodyClassName='text-center' sortField='examName' field="examName" header="Exam Name" />
                    <Column style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} sortable headerClassName="text-color-secondary" bodyClassName='text-center' sortField='testType' field="testType" header="Test Type" />


                    {this.isColumnVisible('totalNoOfQuestions') && <Column style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} sortable headerClassName="text-color-secondary" bodyClassName='text-center' sortField='totalNoOfQuestions' field="totalNoOfQuestions" header="Total Number of Questions" />}
                    {this.isColumnVisible('totalMarkedQuestions') && <Column style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} sortable headerClassName="text-color-secondary" bodyClassName='text-center' sortField='totalMarkedQuestions' field="totalMarkedQuestions" header="Total Marked Questions" />}
                    {this.isColumnVisible('totalTime') && <Column style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} sortable headerClassName="text-color-secondary" bodyClassName='text-center' sortField='totalTime' field="totalTime" header="Total Time" />}
                    {this.isColumnVisible('totalMarks') && <Column style={{ width: "15rem", height: "6rem" }} alignHeader={"center"} sortable headerClassName="text-color-secondary" bodyClassName='text-center' sortField='totalMarks' field="totalMarks" header="Total Marks" />}

                    <Column className=' ' alignHeader={"center"} header="Actions" body={(rowData, { rowIndex }) => {
                        const canAssign = this.isExamAssignable(rowData);

                        return (<>
                            <div className="flex justify-content-center align-items-center">
                                {/* <Authorizer permId={PERMISSIONS.EXAM_EDIT_ADHOC} > */}
                                <span data-pr-tooltip="Edit Test" data-pr-position="bottom" className={`b${rowIndex} ma-mr20 ml-3`} onClick={() => { this.props.onEditExam(rowData.examId, 'AdhocMockTest') }}>
                                    <SvgViewer className='ma-icon-svg ma-pointer' src='new-assets/edit.svg' width="20" height="20" />
                                </span>
                                <Tooltip className="table-li-tooltip2" autoHide={false} target={`.b${rowIndex}`} />

                                {/* Clone Test */}
                                <span data-pr-tooltip="Clone Test" data-pr-position="bottom" className={`clone${rowIndex} ma-mr20 ml-3`} onClick={() => { this.props.onCloneExam(rowData.examId, 'AdhocMockTest') }}>
                                    <i className='pi pi-copy' style={{ fontSize: '20px', color: "#000" }}></i>
                                </span>
                                <Tooltip className="table-li-tooltip2" autoHide={false} target={`.clone${rowIndex}`} />
                                {/* </Authorizer> */}
                                {/* <Authorizer permId={PERMISSIONS.EXAM_ASSIGN_ADHOC} > */}
                                <span
                                    data-pr-tooltip={canAssign ?
                                        "Assign Test" :
                                        "Test can only be assigned between start and end date"}
                                    data-pr-position="bottom"
                                    className={`e${rowIndex} ml-3`}
                                    onClick={() => {
                                        if (canAssign) {
                                            this.assignExam(rowData);
                                        }
                                    }}
                                    style={{
                                        opacity: canAssign ? 1 : 0.5,
                                        cursor: canAssign ? 'pointer' : 'not-allowed'
                                    }}
                                >
                                    <AssignIcon width="20" height="20" />
                                </span>
                                <Tooltip className="table-li-tooltip2" autoHide={false} target={`.e${rowIndex}`} />
                                {/* </Authorizer> */}
                                {/* <Authorizer permId={PERMISSIONS.EXAM_PAPER_DOWNLOAD} > */}
                                <span data-pr-tooltip="Download Paper" data-pr-position="bottom" className={`e${rowIndex} ml-3`} onClick={() => { this.showDownloadDialog(rowData) }}>
                                    <i className='pi pi-download' style={{ fontSize: '20px' }}></i>
                                </span>

                                <Tooltip className="table-li-tooltip2" autoHide={false} target={`.e${rowIndex}`} />
                                {/* </Authorizer> */}
                                {/* <Authorizer permId={PERMISSIONS.EXAM_UPLOAD_EXAM_RESULTS} > */}
                                <span data-pr-tooltip="Upload Exam Results" data-pr-position="bottom" className={`e3pa${rowIndex} ml-3`} onClick={() => { this.showUploadResult(rowData) }}>
                                    <i className='pi pi-upload' width="20" height="20" />

                                </span>
                                <Tooltip className="table-li-tooltip2" autoHide={false} target={`.e3pa${rowIndex}`} />
                                {/* </Authorizer> */}
                                {/* <Authorizer permId={PERMISSIONS.EXAM_DOWNLOAD_REPORTS} > */}
                                <span data-pr-tooltip="Download Exam Reports" data-prPosition="bottom" className={`epa${rowIndex} ml-3`} onClick={() => { this.genAndDownloadReport(rowData) }}>
                                    <i className='pi pi-cloud-download' style={{ fontSize: '20px' }} />
                                </span>
                                <Tooltip className="table-li-tooltip2" autoHide={false} target={`.epa${rowIndex}`} />
                                {/* </Authorizer> */}

                                {/* <Authorizer permId={PERMISSIONS.EXAM_RECALCULATE} > */}
                                <span data-pr-tooltip="Recalculate" data-pr-position="bottom" className={`e3pa${rowIndex} ml-3`} onClick={() => { this.recalculateExam(rowData) }}>
                                    <i className='pi pi-book' width="20" height="20" />
                                </span>
                                <Tooltip className="table-li-tooltip2" autoHide={false} target={`.abc${rowIndex}`} />
                                {/* </Authorizer> */}
                                {/* <Authorizer permId={PERMISSIONS.EXAM_RELOAD_EXAM_QUESTIONS} > */}
                                <span data-pr-tooltip="Reload Exam Questions" data-prPosition="bottom" className={`abc${rowIndex} ml-3`} onClick={() => { this.reloadExamQuestions(rowData) }}>
                                    <i className='pi pi-refresh' width="20" height="20" />
                                </span>
                                <Tooltip className="table-li-tooltip2" autoHide={false} target={`.abc${rowIndex}`} />
                                {/* </Authorizer> */}
                                {/* <Authorizer permId={PERMISSIONS.EXAM_ADHOC_EXPORT} > */}
                                <span
                                    data-pr-tooltip={rowData.exported ? `Re-export Exam (Already exported on ${rowData.lastExportDate ? moment(rowData.lastExportDate).format('MMM Do, h:mm a') : 'N/A'})` : "Export Exam"}
                                    data-pr-position="bottom"
                                    className={`ewa${rowIndex} ml-3`}
                                    onClick={() => { this.showExportConfirm(rowData) }}
                                    style={rowData.exported ? { color: '#4CAF50', cursor: 'pointer' } : {}}
                                >
                                    <ExportIcon width="20" height="20" />
                                </span>
                                <Tooltip className="table-li-tooltip2" autoHide={false} target={`.ewa${rowIndex}`} />
                                {/* </Authorizer> */}

                                {/* <span 
                                data-pr-tooltip="Key Download" 
                                data-pr-position="bottom" 
                                className={`e${rowIndex} ml-3`} 
                                // onClick={() => { this.showDownloadDialog(rowData) }}
                                onClick={() => { this.downloadKey(rowData) }}
                                >
                                    <i className='pi pi-download' style={{ fontSize: '20px' }}></i>
                                </span>

                                <Tooltip className="table-li-tooltip2" autoHide={false} target={`.e${rowIndex}`} /> */}

                                <span
                                    data-pr-tooltip="Key Download"
                                    data-pr-position="bottom"
                                    className={`e${rowIndex} ml-3`}
                                    onClick={() => { this.downloadKey(rowData) }}
                                >
                                    <i className='pi pi-download' style={{ fontSize: '20px' }}></i>
                                </span>
                                <Tooltip className="table-li-tooltip2" autoHide={false} target={`.e${rowIndex}`} />

                                <span
                                    data-pr-tooltip="Notify Parents about Results"
                                    data-pr-position="bottom"
                                    className={`notify${rowIndex} ml-3`}
                                    onClick={() => { this.handleNotifyParents(rowData) }}
                                >
                                    <i className='pi pi-send' style={{ fontSize: '20px' }}></i>
                                </span>
                                <Tooltip className="table-li-tooltip2" autoHide={false} target={`.notify${rowIndex}`} />

                            </div>
                        </>
                        );
                    }} ></Column>
                    {/* <Column header="Topics" body={this.showChaptersTemplate}></Column> */}
                </DataTable>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </div >


            {this.state.isShowAssignDialog && (
                <AssignExamToSection
                    examToAssign={this.state.examToAssign}
                    onClose={() => this.setState({ isShowAssignDialog: false })}
                    onAssignSuccess={() => {
                        this.setState({ isShowAssignDialog: false });
                        this.onSearch(); // Refresh list after assignment
                    }}
                />
            )}

            {
                this.state.isLoading && <LoadingComponent />
            }

            <Dialog
                header={<></>}
                draggable={false}
                closeOnEscape={true}
                className='ma-alert-box'
                blockScroll={true}
                dismissableMask={true}
                closable={false}
                visible={this.state.warningDialog.visible} style={{ maxWidth: '22vw', minWidth: '300px' }}
                footer={() => {
                    return (<div>
                        <Button label="No" className='p-button-outlined' onClick={() => { this.setState({ warningDialog: warningDailogInit, editRoleData: null }) }} />
                        <Button label="Yes" className='ma-m-lr10 p-button-raised' onClick={this.onConfirmExport} />

                    </div>)
                }}
                onHide={() => this.setState({ warningDialog: warningDailogInit, exportExamDetails: null })}>
                <div>
                    <span className="warning-icon flex justify-content-center" >
                        <WarningIcon width={"30%"} height={"30%"} />
                    </span>
                </div>
                <p className='text-xl mt-2 text-900 font-bold flex justify-content-center'>{this.state.warningDialog.headerMsg}</p>
                <p className='text-lg text-600 text-center font-bold white-space-normal'>{this.state.warningDialog.message}</p>
            </Dialog>


            {this.state.isShowUploadResult && <AdhocExamResultUpload onHide={() => {
                this.setState({
                    isShowUploadResult: false,
                    uploadResultExam: null
                })
            }} uploadResultExam={this.state.uploadResultExam} />}

            <Dialog
                visible={this.state.showDownloadDialog}
                onHide={() => this.setState({ showDownloadDialog: false })}
                style={{ width: '450px' }}
                header="Download Paper"
                modal
                footer={() => (
                    <div className='flex justify-content-end'>
                        <Button
                            label="Cancel"
                            className='p-button-outlined'
                            onClick={() => this.setState({ showDownloadDialog: false })}
                        />
                        <Button
                            label="Download"
                            className='p-button-raised ml-2'
                            onClick={this.downloadPaperWithDate}
                        />
                    </div>
                )}
            >
                <div className="flex flex-column">
                    <h5>Please select the exam date:</h5>
                    <Calendar
                        id="examDate"
                        value={this.state.selectedExamDate}
                        onChange={(e) => this.setState({ selectedExamDate: e.value })}
                        showIcon
                        dateFormat="dd/mm/yy"
                        className="w-full mb-3"
                    />
                    <small className="text-muted">
                        The selected date will be displayed on the exam paper.
                    </small>
                </div>
            </Dialog>
        </>)
    }
}
